import gql from 'graphql-tag';

export const GET_LISTA_SEGMENTOS = gql(`
    query ListadoSegmentos {
      listadoSegmentos {
        id
        activo
        nombre
        isUsedSegmento
        atributos {
          descripcion
          bigintPorDefecto
          doublePorDefecto
          formatoFecha
          id
          idSegmento
          listadoValoresResponse {
            id
            lista
            nombre
          }
          maximo
          maximoDouble
          minimo
          minimoDouble
          nivel
          nombre
          nullable
          numeroDecimales
          orden
          textPorDefecto
          tipoAtributoResponse {
            codigo
            descripcion
            id
            nombre
          }
          validadorEspecificoResponse {
            codigo
            descripcion
            id
            nombre
            tipoAtributoResponse {
              codigo
              descripcion
              id
              nombre
            }
          }
        }
      }
    }
  `)

export const ALTA_SEGMENTO = gql(`
    mutation AltaSegmento($altaSegmento: AltaSegmentoRequestInput) {
      altaSegmento(altaSegmento: $altaSegmento) {
        id
      }
    }
  `)

export const MODIFICAR_SEGMENTO = gql(`
    mutation ModificarSegmento($modificarSegmentoRequest: ModificarSegmentoRequestInput) {
      modificarSegmento(ModificarSegmentoRequest: $modificarSegmentoRequest) {
        id
      }
    }
  `)

export const BORRAR_SEGMENTO = gql(`
    mutation BorrarSegmento($borrarSegmentoId: Int) {
      borrarSegmento(id: $borrarSegmentoId)
    }
  `)

export const GET_SEGMENTO = gql(`
    query Segmento($idSegmento: Int) {
      segmento(idSegmento: $idSegmento) {
        id
        activo
        nombre
        isUsedSegmento
        atributos {
          descripcion
          bigintPorDefecto
          doublePorDefecto
          formatoFecha
          id
          idSegmento
          listadoValoresResponse {
            id
            lista
            nombre
          }
          maximo
          maximoDouble
          minimo
          minimoDouble
          nivel
          nombre
          nullable
          numeroDecimales
          orden
          textPorDefecto
          tipoAtributoResponse {
            codigo
            descripcion
            id
            nombre
          }
          validadorEspecificoResponse {
            codigo
            descripcion
            id
            nombre
            tipoAtributoResponse {
              codigo
              descripcion
              id
              nombre
            }
          }
        }
      }
    }
  `)
export const IS_USED_SEGMENTO = gql(`
  query ExampleQuery($isUsedSegmentoId: Int) {
    isUsedSegmento(id: $isUsedSegmentoId)
  }
`)